export default {
  BusinessOrderAuditCom: {
    skuTitle: '按商品汇总',
    skuItemTitle: '按商品行明细',
    hangUp: '挂起',
    confirmTextHangUp: '是否确认挂起？',
    hang: '解挂',
    confirmTextHang: '是否确认解挂？',
    receipt: '确认收货',
    confirmTextReceipt: '是否确认收货？',
    blackAndWhiteList: '设置黑白名单'
  },
  BusinessOrderAuditComSkuList: {
    receivingStatus: '收货状态',
    deliveryStatus: '发货状态',
    preemptionStatus: '预占状态',
    sourceStatus: '寻源状态',
    suspendStatus: '挂起状态',
    syncPreempStatus: '预占回写状态',
    syncDeliveryStatus: '发货回写状态',
    receipt: '确认收货',
    hangUp: '挂起',
    hang: '解挂',
    cover: '套',
    giftFlag: '是否赠品',
    quantity: '数量',
    thirdSaleAmount: '三方平台销售单价',
    outBalancePrice: '三方平台均摊总价',
    innerSalePrice: '内部销售价',
    innerBalancePrice: '内部均摊总价',
    costAmount: '成本单价',
    totalCostAmount: '成本总价',
    transPrice: '运费',
    msgWarning: '返回数据为空，请联系管理员',

  }
};
